import { useUser } from '~/stores/user/user'
import { isAdminRole } from '~/utils/roles'

export default defineNuxtRouteMiddleware(() => {
  const { state: user } = useUser()

  // Перевіряємо чи користувач існує (auth middleware має виконатись першим)
  if (!user.value) {
    return navigateTo('/login')
  }

  if (!isAdminRole(user.value.role)) {
    return navigateTo('/')
  }
})
